import axios from 'axios';

var cms_api_url = 'https://api-eu-central-1.graphcms.com/v2/ckt428zb80f7g01yz95dy0p07/master'; // need to replace

// import constants
function cms (query) {
  return fetch(cms_api_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query
    })
  }).then(function (res) {
    return res.json();
  }).then(function (res) {
    return {
      data: res.data
    };
  }).catch(function () {});
}

function axiosPost$1(endpoint, data, token, callback) {
  var fullCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  axios.post(endpoint, data, {
    headers: {
      Authorization: "Bearer ".concat(token),
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    if (fullCallback) {
      callback(res);
    } else {
      callback(res.data);
    }
  }).catch(function (error) {
    callback(error.response.data); // post error to component
    var errorDetails = "api endpoint: ".concat(endpoint, " , error: ").concat(error, "  , pagename: ").concat(window && window.location);
    // post error in logs history if needed
    console.log(errorDetails);
  });
}
function axiosGet(endpoint, token, callback) {
  var fullCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  axios.get(endpoint, {
    headers: {
      Authorization: "Bearer ".concat(token)
    }
  }).then(function (res) {
    if (fullCallback) {
      callback(res);
    } else {
      callback(res.data);
    }
  }).catch(function (error) {
    var errorDetails = "api endpoint: ".concat(endpoint, " , error: ").concat(error, "  , pagename: ").concat(window && window.location);
    // post error in logs history if needed
    console.log(errorDetails);
  });
}
function axiosPut(endpoint, data, token, callback) {
  axios.put(endpoint, data, {
    headers: {
      Authorization: "Bearer ".concat(token),
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    callback(res.data);
  }).catch(function (error) {
    callback(error.response.data); // post error to component
    var errorDetails = "api endpoint: ".concat(endpoint, " , error: ").concat(error, "  , pagename: ").concat(window && window.location);
    // post error in logs history if needed
    console.log(errorDetails);
  });
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_typeof_1);

var regeneratorRuntime$1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _regeneratorRuntime() {
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(regeneratorRuntime$1);

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

var getData = function getData(key) {
  return localStorage.getItem(key);
};
var setData = function setData(key, value) {
  localStorage.setItem(key, value);
};
var removeData = function removeData(key) {
  localStorage.removeItem(key);
};
var clearData = function clearData() {
  localStorage.clear();
};

var api_url = process.env.VUE_APP_API_URL;

// export const api_url = cors_url + geturl; // to byPass cors security enable this line

// users endpoints
var user_details_endpoint = "".concat(api_url, "User");
var user_profile_update_endpoint = "".concat(api_url, "User/");
var temptoken_endpoint = "".concat(api_url, "User/token");
var signin_endpoint = "".concat(api_url, "User/authenticate");
var signup_endpoint = "".concat(api_url, "User/registersimple");
var forgotpassword_endpoint = "".concat(api_url, "User/forgotpassword");
var updatepasswordforget_endpoint = "".concat(api_url, "User/updatepasswordforget");
var updatepassword_endpoint = "".concat(api_url, "User/updatepassword");
var updateusername_endpoint = "".concat(api_url, "User/updateUsername");
var getuserprofile_endpoint = "".concat(api_url, "User/Profile");
var activate_on_invetation_endpoint = "".concat(api_url, "User/activateOnInvitation");
var switch_customer_enpoint = "".concat(api_url, "User/customerSwitch");
var cancel_subscription_enpoint = "".concat(api_url, "User/cancelsubscription");

// media endpoints
var media_endpoint = "".concat(api_url, "Media");
var mediadetails_endpoint = "".concat(api_url, "Media/");

// video content endpoints
var video_content_endpoint = "".concat(api_url, "VideoContent/list");
var video_content_details_endpoint = "".concat(api_url, "VideoContent/");
var video_content_details_by_slug_endpoint = "".concat(api_url, "VideoContent/Slug/");
var video_content_videos_type_endpoint = "".concat(api_url, "VideoContent/");
var video_get_multiple_endpoint = "".concat(api_url, "VideoContent/GetMultiple");

// playlists endpoints
var playlist_list_endpoint = "".concat(api_url, "PlayList/list");
var playlist_by_id_endpoint = "".concat(api_url, "PlayList/");

// Pages endpoints
var page_list_endpoint = "".concat(api_url, "Page/list");
var page_by_id_endpoint = "".concat(api_url, "Page/");
var page_by_slug_endpoint = "".concat(api_url, "Page/Slug/");

//TemplateContent
var template_content_list_endpoint = "".concat(api_url, "TemplateContent/list/");
var template_content_by_id_endpoint = "".concat(api_url, "TemplateContent/");
var template_content_by_slug_endpoint = "".concat(api_url, "TemplateContent/slug/");

// Tabs endpoints
var tabfields_list_endpoint = "".concat(api_url, "TabFields");
var tabfields_by_type_endpoint = "".concat(api_url, "TabFields/");
var tabfields_fields_flat_endpoint = "".concat(api_url, "TabFields/Fields");

// video assets endpoints
var video_asset_endpoint = "".concat(api_url, "VideoAsset/");
var video_multiple_asset_endpoint = "".concat(api_url, "VideoAsset/GetMultiple");

// CMS media assets endpoints
var cms_get_media_by_id_endpoint = "".concat(api_url, "CmsMedia/");

// Priceplan endpoints
var priceplan_list_endpoint = "".concat(api_url, "PricePlan");
var priceplan_by_id_endpoint = "".concat(api_url, "PricePlan/");

// order endpoints
var get_orders_endpoint = "".concat(api_url, "Order");

// checkout endpoints
var checkout_payperview_endpoint = "".concat(api_url, "Checkout/StartPaymentMedia");
var checkout_subscription_endpoint = "".concat(api_url, "Checkout/StartPaymentSubscription");

// Content endpoints
var content_endpoint = "".concat(api_url, "Content");
var content_detail_endpoint = "".concat(api_url, "Content/");

// Enumeration endpoints
var enumeration_values_endpoint = "".concat(api_url, "EnumerationValues");
var enumeration_nested_values_endpoint = "".concat(api_url, "EnumerationValues/Nested");
var enumeration_values_flat_endpoint = "".concat(api_url, "EnumerationValues/Flat");

var fetchTempToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var res, tempTokenData;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("".concat(temptoken_endpoint, "?id=").concat(process.env.VUE_APP_CUSTOMER_ID), {
              headers: {
                'Access-Control-Allow-Origin': 'http://localhost:8080'
              }
            });
          case 2:
            res = _context.sent;
            if (!res.data.token) {
              _context.next = 7;
              break;
            }
            tempTokenData = JSON.stringify({
              date: new Date(),
              tempToken: res.data.token
            });
            setData('tempTokenData', tempTokenData);
            return _context.abrupt("return", res.data.token);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchTempToken() {
    return _ref.apply(this, arguments);
  };
}();
var getTempToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var callback,
      data,
      date,
      now,
      difference,
      resultInMinutes,
      token,
      _token,
      _args2 = arguments;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            callback = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : function () {};
            data = getData('tempTokenData') ? JSON.parse(getData('tempTokenData')) : null;
            if (!data) {
              _context2.next = 10;
              break;
            }
            date = new Date(data.date);
            now = new Date();
            difference = now.getTime() - date.getTime();
            resultInMinutes = Math.round(difference / 60000);
            if (resultInMinutes <= 9) {
              // return stored tempToken
              callback(data.tempToken);
            } else {
              // fetch new tempToken
              token = fetchTempToken();
              callback(token);
            }
            _context2.next = 14;
            break;
          case 10:
            _context2.next = 12;
            return fetchTempToken();
          case 12:
            _token = _context2.sent;
            callback(_token);
          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getTempToken() {
    return _ref2.apply(this, arguments);
  };
}();
var registerUser = function registerUser(username, password, role) {
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  getTempToken(function (tempToken) {
    var userData = JSON.stringify({
      customerId: process.env.VUE_APP_CUSTOMER_ID,
      username: username,
      password: password,
      role: role
    });
    axiosPost$1(signup_endpoint, userData, tempToken, function (response) {
      if (response.resultCode === 1000) {
        var loginData = JSON.stringify({
          date: new Date(),
          role: response.role,
          token: response.token,
          userName: response.userName,
          subscription: response.subscription
        });
        setData('loginData', loginData);
        callback(response);
      } else {
        callback(response);
      }
    });
  });
};
var authenticateUser = function authenticateUser(username, password) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  getTempToken(function (tempToken) {
    var userData = JSON.stringify({
      username: username,
      password: password
    });
    axiosPost$1(signin_endpoint, userData, tempToken, function (response) {
      if (response.resultCode === 1000) {
        var loginData = JSON.stringify({
          date: new Date(),
          role: response.role,
          token: response.token,
          userName: response.userName,
          subscription: response.subscription
        });
        setData('loginData', loginData);
        callback(response.token);
      } else {
        callback(response);
      }
    });
  });
};
var getUserToken = function getUserToken(callback) {
  var data = JSON.parse(getData('loginData'));
  var date = new Date(data.date);
  var now = new Date();
  var diff = (now.getTime() - date.getTime()) / 1000;
  diff /= 90 * (24 * 60); // compare token for 90 days

  if (Math.abs(Math.round(diff)) < 60) {
    callback(data.token);
  } else {
    clearData(); // ask user to login again
  }
};

var getAuthToken = function getAuthToken(isAuthenticated) {
  return new Promise(function (resolve, reject) {
    if (isAuthenticated) {
      getUserToken(function (token) {
        resolve(token);
      });
    } else {
      getTempToken(function (token) {
        resolve(token);
      });
    }
  });
};
var adminSwitchCustomer = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated) {
    var authToken;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context3.sent;
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(switch_customer_enpoint, "?customerId=").concat(process.env.VUE_APP_CUSTOMER_ID), '', authToken, function (response) {
                if (response.resultCode === 1000) {
                  var loginData = JSON.stringify({
                    date: new Date(),
                    role: response.role,
                    token: response.token,
                    userName: response.userName,
                    subscription: response.subscription
                  });
                  setData('loginData', loginData);
                  resolve(response.token);
                } else {
                  resolve(response);
                }
              });
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function adminSwitchCustomer(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var forgotPassword = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context4.sent;
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(forgotpassword_endpoint).concat(parameters), '', authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function forgotPassword(_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();
var updatePassword = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context5.sent;
            return _context5.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(updatepassword_endpoint).concat(parameters), '', authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function updatePassword(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();
var resetPassword = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(token, parameters) {
    return regenerator.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(updatepasswordforget_endpoint).concat(parameters), '', token, function (response) {
                resolve(response);
              });
            }));
          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function resetPassword(_x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();
var updateUserName = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context7.sent;
            return _context7.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(updateusername_endpoint).concat(parameters), '', authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function updateUserName(_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();
var activateAccount = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context8.sent;
            return _context8.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(activate_on_invetation_endpoint).concat(parameters), '', authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return function activateAccount(_x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();
var getUserInfo = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(token) {
    return regenerator.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", new Promise(function (resolve, reject) {
              axiosGet(user_details_endpoint, token, function (response) {
                resolve(response);
              });
            }));
          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return function getUserInfo(_x12) {
    return _ref9.apply(this, arguments);
  };
}();
var getUserProfile = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10(token) {
    return regenerator.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", new Promise(function (resolve, reject) {
              axiosGet(getuserprofile_endpoint, token, function (response) {
                resolve(response);
              });
            }));
          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return function getUserProfile(_x13) {
    return _ref10.apply(this, arguments);
  };
}();
var updateUserProfileDetails = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(token, userId, content) {
    return regenerator.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", new Promise(function (resolve, reject) {
              axiosPut("".concat(user_profile_update_endpoint).concat(userId), content, token, function (response) {
                resolve(response);
              });
            }));
          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return function updateUserProfileDetails(_x14, _x15, _x16) {
    return _ref11.apply(this, arguments);
  };
}();
var cancelSubscription = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context14.sent;
            return _context14.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(cancel_subscription_enpoint).concat(parameters), '', authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return function cancelSubscription(_x23, _x24) {
    return _ref14.apply(this, arguments);
  };
}();

var fetchMediaList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated) {
    var sortBy,
      parameters,
      url,
      authToken,
      mediaResponse,
      _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sortBy = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'default';
            parameters = _args.length > 2 ? _args[2] : undefined;
            url = parameters ? media_endpoint + parameters : media_endpoint;
            _context.next = 5;
            return getAuthToken(isAuthenticated);
          case 5:
            authToken = _context.sent;
            mediaResponse = new Promise(function (resolve, reject) {
              axiosGet(url, authToken, function (response) {
                switch (sortBy) {
                  case 'date':
                    mediaResponse = response.sort(function (a, b) {
                      return Date.parse(a.date) - Date.parse(b.date);
                    });
                    break;
                  case 'number':
                    mediaResponse = response.sort(function (a, b) {
                      return Date.parse(a.sortOrder) - Date.parse(b.sortOrder);
                    });
                    break;
                  default:
                    mediaResponse = response;
                    break;
                }
                resolve(mediaResponse);
              });
            });
            _context.next = 9;
            return mediaResponse;
          case 9:
            return _context.abrupt("return", _context.sent);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchMediaList(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchMediaDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, mediaId, parameters) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(mediadetails_endpoint).concat(mediaId).concat(parameters), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 6;
            return promiseResponse;
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchMediaDetails(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchVideoContentList = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated, parameters) {
    var fullCallback,
      authToken,
      _args3 = arguments;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fullCallback = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
            _context3.next = 3;
            return getAuthToken(isAuthenticated);
          case 3:
            authToken = _context3.sent;
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1(video_content_endpoint, parameters, authToken, function (response) {
                resolve(response);
              }, fullCallback);
            }));
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function fetchVideoContentList(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
var fetchVideoContentDetails = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(isAuthenticated, mediaId, parameters) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context4.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(video_content_details_endpoint).concat(mediaId).concat(parameters), authToken, function (response) {
                resolve(response);
              });
            });
            _context4.next = 6;
            return promiseResponse;
          case 6:
            return _context4.abrupt("return", _context4.sent);
          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function fetchVideoContentDetails(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
var fetchVideoContentBySlugDetails = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(isAuthenticated, slug, params) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context5.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(video_content_details_by_slug_endpoint).concat(slug).concat(params), authToken, function (response) {
                resolve(response);
              });
            });
            _context5.next = 6;
            return promiseResponse;
          case 6:
            return _context5.abrupt("return", _context5.sent);
          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function fetchVideoContentBySlugDetails(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
var fetchVideoContentVideoType = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(isAuthenticated, mediaId, mediaType) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context6.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(video_content_videos_type_endpoint).concat(mediaId, "/").concat(mediaType), authToken, function (response) {
                resolve(response);
              });
            });
            _context6.next = 6;
            return promiseResponse;
          case 6:
            return _context6.abrupt("return", _context6.sent);
          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function fetchVideoContentVideoType(_x13, _x14, _x15) {
    return _ref6.apply(this, arguments);
  };
}();
var fetchVideoAsset = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(isAuthenticated, mediaId) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context7.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(video_asset_endpoint).concat(mediaId), authToken, function (response) {
                resolve(response);
              });
            });
            _context7.next = 6;
            return promiseResponse;
          case 6:
            return _context7.abrupt("return", _context7.sent);
          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function fetchVideoAsset(_x16, _x17) {
    return _ref7.apply(this, arguments);
  };
}();
var fetchMultipleVideoAssets = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(isAuthenticated, obj) {
    var authToken;
    return regenerator.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context8.sent;
            return _context8.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(video_multiple_asset_endpoint), obj, authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return function fetchMultipleVideoAssets(_x18, _x19) {
    return _ref8.apply(this, arguments);
  };
}();
var fetchMultipleVideos = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(isAuthenticated, parameters, obj) {
    var authToken;
    return regenerator.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context9.sent;
            return _context9.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(video_get_multiple_endpoint).concat(parameters), obj, authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return function fetchMultipleVideos(_x20, _x21, _x22) {
    return _ref9.apply(this, arguments);
  };
}();

var fetchContentList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated, parameters) {
    var authToken, url, promiseResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            url = parameters ? content_endpoint + parameters : content_endpoint;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet(url, authToken, function (response) {
                resolve(response);
              });
            });
            _context.next = 7;
            return promiseResponse;
          case 7:
            return _context.abrupt("return", _context.sent);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchContentList(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchContentDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, contentId, parameters) {
    var authToken, url, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            url = parameters ? "".concat(content_detail_endpoint).concat(contentId).concat(parameters) : "".concat(content_detail_endpoint).concat(contentId);
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet(url, authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 7;
            return promiseResponse;
          case 7:
            return _context2.abrupt("return", _context2.sent);
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchContentDetails(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getOrders = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet(get_orders_endpoint, authToken, function (response) {
                resolve(response);
              });
            });
            _context.next = 6;
            return promiseResponse;
          case 6:
            return _context.abrupt("return", _context.sent);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getOrders(_x) {
    return _ref.apply(this, arguments);
  };
}();
var checkoutPayperview = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, bodyData) {
    var authToken;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1(checkout_payperview_endpoint, bodyData, authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function checkoutPayperview(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var checkoutSubscription = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated, bodyData) {
    var authToken;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context3.sent;
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1(checkout_subscription_endpoint, bodyData, authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function checkoutSubscription(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchEnumValues = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(enumeration_values_endpoint), authToken, function (response) {
                resolve(response);
              });
            });
            _context.next = 6;
            return promiseResponse;
          case 6:
            return _context.abrupt("return", _context.sent);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchEnumValues(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchNestedEnumValues = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(enumeration_nested_values_endpoint), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 6;
            return promiseResponse;
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchNestedEnumValues(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchEnumFlatValues = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context3.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(enumeration_values_flat_endpoint), authToken, function (response) {
                resolve(response);
              });
            });
            _context3.next = 6;
            return promiseResponse;
          case 6:
            return _context3.abrupt("return", _context3.sent);
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function fetchEnumFlatValues(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchPlaylistList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost(playlist_list_endpoint, parameters, authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchPlaylistList(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchPlaylistById = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, playlistId) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(playlist_by_id_endpoint).concat(playlistId), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 6;
            return promiseResponse;
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchPlaylistById(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchPageList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated, parameters) {
    var authToken;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost(page_list_endpoint, parameters, authToken, function (response) {
                resolve(response);
              });
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchPageList(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchPageById = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, pageId) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(page_by_id_endpoint).concat(pageId), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 6;
            return promiseResponse;
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchPageById(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchPageBySlug = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated, slug) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context3.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(page_by_slug_endpoint).concat(slug), authToken, function (response) {
                resolve(response);
              });
            });
            _context3.next = 6;
            return promiseResponse;
          case 6:
            return _context3.abrupt("return", _context3.sent);
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function fetchPageBySlug(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchTemplateContentList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated, templateId, parameters) {
    var stringParams,
      fullCallback,
      authToken,
      url,
      _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            stringParams = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
            fullCallback = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
            _context.next = 4;
            return getAuthToken(isAuthenticated);
          case 4:
            authToken = _context.sent;
            url = stringParams ? template_content_list_endpoint + "".concat(templateId) + stringParams : template_content_list_endpoint + "".concat(templateId);
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              axiosPost$1("".concat(url), parameters, authToken, function (response) {
                resolve(response);
              }, fullCallback);
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchTemplateContentList(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var fetchTemplateContentDetailsById = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, contentId) {
    var stringParams,
      authToken,
      url,
      promiseResponse,
      _args2 = arguments;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            stringParams = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
            _context2.next = 3;
            return getAuthToken(isAuthenticated);
          case 3:
            authToken = _context2.sent;
            url = stringParams ? template_content_by_id_endpoint + "".concat(contentId) + stringParams : template_content_by_id_endpoint + "".concat(contentId);
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(url), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 8;
            return promiseResponse;
          case 8:
            return _context2.abrupt("return", _context2.sent);
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchTemplateContentDetailsById(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchTemplateContentDetailsBySlug = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated, contentId) {
    var stringParams,
      authToken,
      url,
      promiseResponse,
      _args3 = arguments;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            stringParams = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : '';
            _context3.next = 3;
            return getAuthToken(isAuthenticated);
          case 3:
            authToken = _context3.sent;
            url = stringParams ? template_content_by_slug_endpoint + "".concat(contentId) + stringParams : template_content_by_slug_endpoint + "".concat(contentId);
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(url), authToken, function (response) {
                resolve(response);
              });
            });
            _context3.next = 8;
            return promiseResponse;
          case 8:
            return _context3.abrupt("return", _context3.sent);
          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function fetchTemplateContentDetailsBySlug(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchCmsMedia = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated, assetId) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(cms_get_media_by_id_endpoint).concat(assetId), authToken, function (response) {
                resolve(response);
              });
            });
            _context.next = 6;
            return promiseResponse;
          case 6:
            return _context.abrupt("return", _context.sent);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchCmsMedia(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchTabfieldsByType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated, type) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(tabfields_by_type_endpoint).concat(type), authToken, function (response) {
                resolve(response);
              });
            });
            _context.next = 6;
            return promiseResponse;
          case 6:
            return _context.abrupt("return", _context.sent);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchTabfieldsByType(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchTabFields = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(tabfields_list_endpoint), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 6;
            return promiseResponse;
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchTabFields(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchTabfieldsFlat = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context3.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(tabfields_fields_flat_endpoint), authToken, function (response) {
                resolve(response);
              });
            });
            _context3.next = 6;
            return promiseResponse;
          case 6:
            return _context3.abrupt("return", _context3.sent);
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function fetchTabfieldsFlat(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchPricePlanList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isAuthenticated) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(priceplan_list_endpoint), authToken, function (response) {
                resolve(response);
              });
            });
            _context.next = 6;
            return promiseResponse;
          case 6:
            return _context.abrupt("return", _context.sent);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetchPricePlanList(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchPricePlanById = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(isAuthenticated, pricePlanId) {
    var authToken, promiseResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAuthToken(isAuthenticated);
          case 2:
            authToken = _context2.sent;
            promiseResponse = new Promise(function (resolve, reject) {
              axiosGet("".concat(priceplan_by_id_endpoint).concat(pricePlanId), authToken, function (response) {
                resolve(response);
              });
            });
            _context2.next = 6;
            return promiseResponse;
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchPricePlanById(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

export { activateAccount, adminSwitchCustomer, authenticateUser, axiosGet, axiosPost$1 as axiosPost, axiosPut, cancelSubscription, checkoutPayperview, checkoutSubscription, clearData, cms, fetchCmsMedia, fetchContentDetails, fetchContentList, fetchEnumFlatValues, fetchEnumValues, fetchMediaDetails, fetchMediaList, fetchMultipleVideoAssets, fetchMultipleVideos, fetchNestedEnumValues, fetchPageById, fetchPageBySlug, fetchPageList, fetchPlaylistById, fetchPlaylistList, fetchPricePlanById, fetchPricePlanList, fetchTabFields, fetchTabfieldsByType, fetchTabfieldsFlat, fetchTemplateContentDetailsById, fetchTemplateContentDetailsBySlug, fetchTemplateContentList, fetchVideoAsset, fetchVideoContentBySlugDetails, fetchVideoContentDetails, fetchVideoContentList, fetchVideoContentVideoType, forgotPassword, getAuthToken, getData, getOrders, getTempToken, getUserInfo, getUserProfile, getUserToken, registerUser, removeData, resetPassword, setData, updatePassword, updateUserName, updateUserProfileDetails };
